import { Icon, IconProps } from '../Icon'

export const EditDocumentIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      edit_document
    </Icon>
  )
}
